// extracted by mini-css-extract-plugin
export var hed = "relatedsection-module--hed--x-kJx";
export var section = "relatedsection-module--section--nmi2b";